'use client';

import Image from 'next/image';

const About = () => {
  return (
    <main className="flex flex-col items-center justify-center px-4 sm:px-8 py-12 max-w-7xl mx-auto">
      <section className="text-center mb-16">
        <h1 className="text-3xl sm:text-4xl font-bold text-blue-800 mb-4">About Us</h1>
        <p className="text-gray-700 text-md sm:text-lg max-w-3xl mx-auto">
          Welcome to <strong>BanksFinders.com</strong> (B F Fintech commercial Brokers LLC), the first AI-based Credit Card and Loan comparison platform in the UAE. 
          Our mission is to simplify your banking decisions by helping you compare and select the best credit cards, personal loans, bank accounts, SME solutions, 
          and mortgages from a wide range of banking partners across the UAE.
        </p>
      </section>

      {/* Section 1 - Image Left, Text Right */}
      <section className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-20">
        <div>
          <Image
            src="/banking-team.jpg"
            alt="Team collaboration"
            width={600}
            height={400}
            className="rounded-2xl shadow-lg w-full h-auto object-cover"
          />
        </div>
        <div className="text-gray-800 space-y-4">
          <h2 className="text-2xl font-semibold text-blue-700">Empowering Decisions</h2>
          <p>
            We are committed to empowering our team and fostering their growth so they can drive innovation and build a resilient, value-driven financial future.
          </p>
        </div>
      </section>

      {/* Section 2 - Text Left, Image Right */}
      <section className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center flex-col-reverse md:flex-row mb-20">
        <div className="text-gray-800 space-y-4 md:order-1 order-2">
          <h2 className="text-2xl font-semibold text-blue-700">Bringing Banks & Customers Together</h2>
          <p>
            Our platform connects banks and customers with ease, offering tailored financial advice and solutions that meet diverse needs. We help you navigate options with confidence.
          </p>
        </div>
        <div className="md:order-2 order-1">
          <Image
            src="/financial-advice.jpg"
            alt="Financial guidance"
            width={600}
            height={400}
            className="rounded-2xl shadow-lg w-full h-auto object-cover"
          />
        </div>
      </section>

      {/* Section 3 - Image Left, Text Right */}
      <section className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <Image
            src="/businessman.jpg"
            alt="Confident decision making"
            width={600}
            height={400}
            className="rounded-2xl shadow-lg w-full h-auto object-cover"
          />
        </div>
        <div className="text-gray-800 space-y-4">
          <h2 className="text-2xl font-semibold text-blue-700">Confident Choices</h2>
          <p>
            At our core, we’re dedicated to helping clients make confident decisions backed by specialized financial expertise. Your financial clarity is our priority.
          </p>
        </div>
      </section>
    </main>
  );
};

export default About;
